import * as React from "react";
const SvgPower20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M9 1v9h2V1H9ZM4.782 5.334l.666-.745-1.49-1.333L3.29 4a9 9 0 1 0 13.52.116l-.654-.757-1.513 1.308.654.756a7 7 0 1 1-10.516-.09Z",
      clipRule: "evenodd"
    })
  );
export default SvgPower20Px;
